function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/* global localStorage */
import BaseStorage from '../base-storage';
import localStorageCleaner from '../utils/local-storage-cleaner';
import { STORAGE_PREFIX, PREFIX_SEPARATOR, KEY_SEPARATOR, NOT_FOUND, LOCAL_STORAGE_UNSUPPORTED } from '../utils/constants';
import { getCacheRecords, deserializeData, isExpired } from '../utils/record-utils';

function getCacheKey(key, options) {
  return getCachePrefix(options) + key;
}

function stringify(obj) {
  return typeof obj === 'string' ? obj : JSON.stringify(obj);
}

function getCachePrefix(options) {
  return [STORAGE_PREFIX, options.namespace, stringify(options.scope)].filter(function (x) {
    return x;
  }).join(PREFIX_SEPARATOR) + KEY_SEPARATOR;
}

function serializeData(value, options) {
  return JSON.stringify({
    lastUsed: Date.now(),
    createdAt: options.createdAt || Date.now(),
    expiration: options.expiration,
    value: value
  });
}

function updateAccessTime(fullKey, data) {
  var expiration = data.expiration,
      createdAt = data.createdAt;
  localStorage.setItem(fullKey, serializeData(data.value, {
    expiration: expiration,
    createdAt: createdAt
  }));
}

var LocalStorageStrategy = /*#__PURE__*/function (_BaseStorage) {
  _inheritsLoose(LocalStorageStrategy, _BaseStorage);

  var _super = _createSuper(LocalStorageStrategy);

  function LocalStorageStrategy() {
    return _BaseStorage.apply(this, arguments) || this;
  }

  var _proto = LocalStorageStrategy.prototype;

  _proto.setItem = function setItem(key, value, options) {
    key = getCacheKey(key, options);
    value = serializeData(value, options);

    try {
      localStorage.setItem(key, value);
    } catch (e) {
      localStorageCleaner(key.length + value.length);
      localStorage.setItem(key, value);
    }

    return Promise.resolve();
  };

  _proto.getItem = function getItem(key, options) {
    var fullKey = getCacheKey(key, options);
    var data;

    try {
      data = localStorage.getItem(fullKey);
    } catch (e) {
      return Promise.reject(LOCAL_STORAGE_UNSUPPORTED);
    }

    data = data && deserializeData(data);

    if (data && !isExpired(data)) {
      updateAccessTime(fullKey, data);
      return Promise.resolve(data.value);
    } else {
      return Promise.reject(NOT_FOUND);
    }
  };

  _proto.removeItem = function removeItem(key, options) {
    key = getCacheKey(key, options);
    localStorage.removeItem(key);
    return Promise.resolve();
  };

  _proto.getAllItems = function getAllItems(options) {
    var prefix = getCachePrefix(options);
    var items = {};
    getCacheRecords(prefix).forEach(function (record) {
      if (!isExpired(record)) {
        items[record.key] = record.value;
      }
    });
    return Promise.resolve(items);
  };

  return LocalStorageStrategy;
}(BaseStorage);

export { LocalStorageStrategy as default };